module.exports = {"api":"http://144.76.222.20:8080","update":"http://www.hampager.de/dapnet-update/update.php","hamnetDb":"http://www.hampager.de/dapnet-update/callsignLocation.php","map":"https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"}


//////////////////
// WEBPACK FOOTER
// ./src/store/defaultUrls.json
// module id = 643
// module chunks = 1